import { makeStyles } from '@material-ui/core/styles';

export const SHARE_HEADER_HEIGHT = 64;

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: '#fff',
    height: SHARE_HEADER_HEIGHT,
    justifyContent: 'center',
    borderBottom: '1px solid #E3E8F0',
  },
  inner: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    paddingLeft: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
    },
  },
  logoContainer: {
    maxWidth: 200,
    [theme.breakpoints.down('sm')]: {
      maxWidth: 150,
    },
  },
  logoImg: {
    width: '100%',
    height: 'auto',
    display: 'block',
  },
  spacer: {
    height: SHARE_HEADER_HEIGHT,
    flexShrink: 0,
  },
}));

export default useStyles;
